<script setup lang="ts">
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import SearchField from '@/components/filter/SearchField.vue';
import { getTranslatedOptions } from '@/utils/helper';
import { UserStateOfUse } from '@/api/generator';
import { I18nKey } from '@/utils/typings';
import { AccountOverviewFilterObject } from '../types';
import { computed } from 'vue';
import PtwResetFilterButton from '@/components/buttons/PtwResetFilterButton.vue';

const modelValue = defineModel<AccountOverviewFilterObject>({ required: true });

const searchedFieldsI18nKeys: I18nKey[] = ['Search'];

const items = computed(() => {
  const statesToRemove: UserStateOfUse[] = [
    UserStateOfUse.Deleted,
    UserStateOfUse.Archived,
    UserStateOfUse.InAdding,
  ];

  return getTranslatedOptions(
    Object.values(UserStateOfUse).filter((state) => !statesToRemove.includes(state)),
    'UserStateOfUseEnum',
  );
});

function clearFilters() {
  modelValue.value = {};
}
</script>

<template>
  <v-row class="align-center mt-2 pl-2 pr-2">
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <SearchField
        v-model="modelValue.search"
        :placeholder="
          $t('SearchPlaceholder', {
            columns: searchedFieldsI18nKeys.map((key) => `$t(${key})`),
          })
        "
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.state"
        :label="$t('StateOfUse')"
        :items="items"
        :placeholder="$t('All')"
        :maxNumDisplayItems="2"
        multiple
        clearable
        chips
        emptyAsUndefined
      ></Autocomplete>
    </v-col>
    <v-col md="3" lg="1" class="d-flex align-center justify-start pa-2">
      <PtwResetFilterButton @click="clearFilters" />
    </v-col>
  </v-row>
</template>
